var exports = {
  "k": "xdbfd91f1--b5ad56--container",
};

module.exports = exports;
